<template>
  <div class="core">
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form ref="allForm" :showForm="true" :rule="form_rulepj" requestUniqueId="appraisePj" :after-save="handleAfterSave">
              <div class="layui-form">
                <pub-collapse :title="formData.WORK_ORDER_CATEGORY === '1' ? '服务请求运维单信息' : '服务请求工程单信息'">
                  <template #content>
                    <layui-collapse>
                      <workOrder ref='workOrder' :editRow="formData"></workOrder>
                    </layui-collapse>
                  </template>
                </pub-collapse>

                <pub-collapse :title="formData.WORK_ORDER_CATEGORY === '1' ? '现场服务运维单信息' : '现场服务工程单信息'">
                  <template #content>
                    <layui-collapse>
                      <serviceOrder ref='serviceOrder' :editRow="formData"></serviceOrder>
                      <signinout ref='signinout' :editRow="formData"></signinout>
                      <selfCheck ref='selfCheck' :editRow="formData"></selfCheck>
                      <acceptance ref='acceptance' :editRow="formData"></acceptance>
                      <backorder ref='backorder'  :editRow="formData"></backorder>
                      <appraise ref='appraise' :enabled="operateType == 'pj'" :editRow="formData"></appraise>
                    </layui-collapse>
                  </template>
                </pub-collapse>
              </div>
              <div class="layui-form-btn">
                <div class="layui-footer">
                  <button class="layui-btn refresh" title="关闭" @click="handleBtnclick('close')">关 闭</button>
                  <button class="layui-btn" title="保存" @click="handleBtnclick('save')" v-if="operateType == 'pj'">保 存</button>
                </div>
              </div>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import workOrder from '../detailForm/workOrderForm'
import serviceOrder from '../detailForm/serviceOrderForm'
import signinout from '../detailForm/signInOutForm'
import selfCheck from '../detailForm/selfCheckForm'
import acceptance from '../detailForm/acceptanceForm'
import backorder from '../detailForm/backOrderForm'
import appraise from '../detailForm/appraiseForm'

export default {
  components: {
    workOrder,
    serviceOrder,
    backorder,
    signinout,
    selfCheck,
    acceptance,
    appraise
  },
  props: {
  },
  data () {
    return {
      form_rulepj: {
      },
      formData: {},
      operateType: '',
      scrollTop: 0
    }
  },
  activated(){
    if(this.scrollTop) {
      $(".core").animate({scrollTop: this.scrollTop}, 0)
    }
  },
  mounted () {
    if(this.tabParam) {
      this.formData = this.tabParam.formData;
      this.operateType = this.tabParam.operateType;
      this.tableObj = this.tabParam.tableObj;
    }
    this.$nextTick(()=> {
      var anchor = this.$refs.appraise.$el.offsetTop;
      $(".core").animate({
        scrollTop: anchor
      },500);
    })

    var that = this;
    $(".core").scroll(function(event){
      that.scrollTop = $(".core").scrollTop();
    })
  },
  methods: {

    /**
     * 保存、关闭
     */
    handleBtnclick(type) {
      switch (type) {
        case 'close': {
          this.baseComponent.closeComponent(this.tabParam.cloneMenu);
          this.baseComponent.loadComponentByName('appraise');
          break
        }
        case 'save': {
          this.$refs.allForm.editRow = this.$refs.backorder.editRow;
            this.$refs.allForm.callableSave("YW_SERVICE_ORDER");
          break
        }
        default: {
          break
        }
      }
    },
    handleAfterSave() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu)
      this.baseComponent.loadComponentByName('appraise')
      if (this.tableObj) {
        this.tableObj.pageInfo.pageIndex = 1
        this.tableObj.load()
      }
    },
  }
}
</script>
<style scoped>
  /* .core .layui-form {
    padding: 10px 20px;
  } */
</style>



// WEBPACK FOOTER //
// src/components/workOrder/apprais/appraiseForm.vue